
import { Button, Card, Col, Flex, Layout, Row, Spin } from "antd";
import UserDepartment from "./UserDepartment";

import { Footer } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styles from "../styles/UserPermission.module.css";
import "./UserPermission.css";
// acmdm = Access Create Modify Delete Manage
const { Header, Sider, Content } = Layout;
function UserPermission({
  selectedRole,
  selectedData,
  roleOptions = [],
  ref = {},
  submit = () => { },
  onRoleSelect = () => { },
  resetData = () => { },
  RecursiveConfig = () => { },
  dataForSave = [],
  showSave
}) {
  const isLoading = useSelector((state) => state.user.isLoading);
  const { t } = useTranslation()
  const { roles } = useSelector((state) => state.company);

  return (
    <Layout style={{
      backgroundColor: 'transparent',
      gap: 10
    }} >
      {/* <div className={styles.container}> */}

      <Layout style={{
        backgroundColor: 'transparent'
      }} >
        <Header
          style={{
            // background: 'transparent',
            backgroundColor: '#0080b3',
            color: 'white',
            position: 'sticky',
            top: 0,
            // zIndex: 129,
            borderRadius: '1rem 1rem 0 0'
          }} >
          <div className={styles.header} style={{
            fontWeight: "bold"
          }} >
            <div>{t('translation.role.entity')}</div>
            <div style={{ textAlign: "center" }}>{t('permission.header')}</div>
          </div>
        </Header>
        <Content style={{
          background: 'transparent',
        }}>
          <Card isLoading={isLoading} style={{
            // background: 'transparent'
            maxHeight: '150vh',
            // overflowY: 'auto',
            borderRadius: '0 0 1rem 1rem',
            position: 'sticky'
          }}>
            <div className={styles.headerTag} style={{
              // background: 'transparent',
              backgroundColor: 'white',
              // color: 'white',
              position: 'sticky',
              top: 0,
              zIndex: 129,
              borderRadius: '1rem 1rem 0 0',
            }}>
              <div></div>
              <div style={{ textAlign: "center" }}>{t('permission.label.access')}</div>
              <div style={{ textAlign: "center" }}>{t('common.create')}</div>
              <div style={{ textAlign: "center" }}>{t('permission.label.modify')}</div>
              <div style={{ textAlign: "center" }}>{t('common.delete')}</div>
            </div>
            {/* {RecursiveConfig({ selectedData })} */}
            <Row>
              <Col span={4} style={{
                // background: 'transparent',
                backgroundColor: 'white',
                // color: 'white',
                position: 'sticky',
                top: 0,
                zIndex: 129,
                borderRadius: '1rem 1rem 0 0'
              }} >
                <UserDepartment
                  selectedRole={selectedRole}
                  roleOptions={roleOptions}
                  onChange={onRoleSelect}
                />
              </Col>
              <Col span={20} style={{
                backgroundColor: '#EDF8FC',
                borderRadius: '1rem',
                height: '65vh',
                overflowY: 'auto', // Allow vertical scrolling
              }}>
                <Spin spinning={isLoading} size="large">
                  <RecursiveConfig selectedData={selectedData} />
                </Spin>
              </Col>
            </Row>
          </Card>
          {/* </div> */}
        </Content>
        <Footer style={{
          ...((!showSave || !roles.includes("UPDATE_USER_MANAGEMENT|PERMISSION")) ? { display: 'none' } : {}),
          zIndex: 999,
          bottom: 2,
          position: 'sticky',
          backgroundColor: 'white',
          height: "max-content",
          placeContent: "center"
        }}>
          <Flex justify="end" gap={20}>
            <Button style={{ width: "100px", height: "44px", borderRadius: "8px", padding: "8px 16px" }}
              onClick={() => {
                resetData()
              }}>
              {t('common.cancel')}
            </Button>
            <Button type="primary" onClick={() => submit()} style={{ width: "100px", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
              {t('common.submit')}
            </Button>
          </Flex>
        </Footer>
      </Layout>
    </Layout>
  );
}

export default UserPermission;
